import * as XLSX from 'xlsx';

export class ExcelTemplateService {
  static generateEmployeeTemplate(): void {
    // Sample data for the template
    const sampleData = [
      {
        'Full Name': 'John Doe',
        'Email': 'john.doe@company.com',
        'Handler': 'johndoe',
        'Phone': '+91 98765 43210',
        'Department': 'engineering',
        'Position': 'Software Developer',
        'Status': 'active',
        'Join Date': '2024-01-15',
        'Profile Picture': 'https://example.com/photos/john.jpg'
      },
      {
        'Full Name': 'Jane Smith',
        'Email': 'jane.smith@company.com',
        'Handler': 'janesmith',
        'Phone': '+91 87654 32109',
        'Department': 'marketing',
        'Position': 'Marketing Manager',
        'Status': 'active',
        'Join Date': '2024-02-01',
        'Profile Picture': ''
      },
      {
        'Full Name': 'Mike Johnson',
        'Email': 'mike.johnson@company.com',
        'Handler': 'mikejohnson',
        'Phone': '+91 76543 21098',
        'Department': 'sales',
        'Position': 'Sales Executive',
        'Status': 'active',
        'Join Date': '2024-01-20',
        'Profile Picture': ''
      },
      {
        'Full Name': 'Sarah Wilson',
        'Email': 'sarah.wilson@company.com',
        'Handler': 'sarahwilson',
        'Phone': '+91 65432 10987',
        'Department': 'hr',
        'Position': 'HR Manager',
        'Status': 'on_leave',
        'Join Date': '2023-12-01',
        'Profile Picture': 'https://example.com/photos/sarah.jpg'
      }
    ];

    // Create workbook
    const workbook = XLSX.utils.book_new();
    
    // Create main sheet with sample data
    const worksheet = XLSX.utils.json_to_sheet(sampleData);
    
    // Auto-resize columns
    const colWidths = Object.keys(sampleData[0]).map(key => {
      const maxLength = Math.max(
        key.length,
        ...sampleData.map(row => (row[key as keyof typeof row] || '').toString().length)
      );
      return { wch: Math.min(maxLength + 2, 50) };
    });
    worksheet['!cols'] = colWidths;
    
    // Add the sheet to workbook
    XLSX.utils.book_append_sheet(workbook, worksheet, 'Employees Sample');
    
    // Create a instructions sheet
    const instructions = [
      { 'Instructions for Employee Import': 'Please follow the guidelines below:' },
      { 'Instructions for Employee Import': '' },
      { 'Instructions for Employee Import': '1. Required Fields (must be filled):' },
      { 'Instructions for Employee Import': '   • Full Name: Employee\'s complete name' },
      { 'Instructions for Employee Import': '   • Email: Valid email address (e.g., user@company.com)' },
      { 'Instructions for Employee Import': '   • Handler: Unique username (letters, numbers, underscore only)' },
      { 'Instructions for Employee Import': '' },
      { 'Instructions for Employee Import': '2. Optional Fields:' },
      { 'Instructions for Employee Import': '   • Phone: Contact number with country code' },
      { 'Instructions for Employee Import': '   • Department: hr, engineering, marketing, sales, finance, operations, support, admin, other' },
      { 'Instructions for Employee Import': '   • Position: Job title or role' },
      { 'Instructions for Employee Import': '   • Status: active, inactive, on_leave, terminated (default: active)' },
      { 'Instructions for Employee Import': '   • Join Date: YYYY-MM-DD format (e.g., 2024-01-15)' },
      { 'Instructions for Employee Import': '   • Profile Picture: Valid URL to image' },
      { 'Instructions for Employee Import': '' },
      { 'Instructions for Employee Import': '3. Important Notes:' },
      { 'Instructions for Employee Import': '   • Do not modify the column headers' },
      { 'Instructions for Employee Import': '   • Email addresses must be unique' },
      { 'Instructions for Employee Import': '   • Handler names must be unique' },
      { 'Instructions for Employee Import': '   • Remove sample data before importing your data' },
      { 'Instructions for Employee Import': '   • Save file as .xlsx or .csv format' },
      { 'Instructions for Employee Import': '' },
      { 'Instructions for Employee Import': '4. Supported File Formats:' },
      { 'Instructions for Employee Import': '   • Excel files (.xlsx, .xls)' },
      { 'Instructions for Employee Import': '   • CSV files (.csv)' }
    ];
    
    const instructionsSheet = XLSX.utils.json_to_sheet(instructions);
    instructionsSheet['!cols'] = [{ wch: 80 }];
    
    // Add instructions sheet
    XLSX.utils.book_append_sheet(workbook, instructionsSheet, 'Instructions');
    
    // Download the file
    XLSX.writeFile(workbook, `employee_import_template_${new Date().toISOString().split('T')[0]}.xlsx`);
  }
}
